import { type FlowGoals } from "features/Library/Flows/types/models";
import { type PackTrialPeriod } from "features/Licensing/Packs/types/state";

export enum TemplateStatusEnum {
  Pending,
  Approved,
  Rejected,
}

export interface TemplateOverview {
  name: string;
  id: number;
  publisher: string;
  users: number;
  customers: number;
  dateCreated: string;
  dateModified: string;
  status: TemplateStatusEnum;
  isOwn: boolean;
  templateGroupId: number | null;
  canEdit: boolean;
}

export interface CustomerView {
  name: string;
  id: number;
  userCount: number;
  added: string;
  isAdded: boolean;
}

export enum TemplatesFiltersEnum {
  DateCreated = "dateCreated",
}

export interface ContentItem {
  id: number;
  publisher: string;
  title: string;
  dateCreated: string;
  dateModified: string;
  isDraft: boolean;
  hasBeenPublished: boolean;
  description: string;
  isPurchased: boolean;
  canBePublished: boolean;
  canBeDeleted: boolean;
  hasAccess: boolean;
  visibility: boolean;
}

export interface FlowItem extends Omit<ContentItem, "visibility"> {
  goals: FlowGoals;
  priorityLevelId: number;
  isInherited: boolean;
  published: boolean;
  dueDate: Nullable<string>;
  canRemove: boolean;
  isEditable: boolean;
  canAutoStart: boolean;
  daysToComplete?: number;
  thumbnailUrl?: string | null;
  hidden: boolean;
}

export interface VideoItem extends ContentItem {
  duration: number;
}

export type TemplateContent = FlowItem | VideoItem | ContentItem;

export type SelectedContentMap = Map<number, TemplateContent>;

export interface PackView {
  id: number;
  title: string;
  thumbnailImageUrl: string;
  isTrialAllowed: boolean;
  trialPeriod: PackTrialPeriod;
  description: string;
  publisher: string;
  publisherId: number;
  dateAdded?: string;
  isAddedToTemplateGroup?: boolean;
  noExpiration?: boolean;
}

export interface AvailablePacksRequest {
  templateGroupId: number;
  skip: number;
  orderBy?: string;
  searchTerm?: string;
}

export enum PackColumns {
  Name = "Pack Name",
  Licenses = "License Count",
  Added = "Issued Date",
  Expiration = "Expiration Date",
}

export enum ContentColumns {
  Title = "Title",
  Publisher = "Publisher",
  Status = "Status",
  Objective = "Objective",
  PriorityLevel = "Priority Level",
}
